import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../components/dialog-wrapper/dialog-wrapper.component';

@Component({
  selector: 'app-symptoms-detail-info',
  standalone: true,
  imports: [DialogWrapperComponent],
  templateUrl: './symptoms-detail-info.component.html',
  styleUrl: './symptoms-detail-info.component.scss'
})
export class SymptomsDetailInfoComponent {
  symptoms : any;
  key :string;

  constructor(
    private dialogRef: MatDialogRef<SymptomsDetailInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.key = data.key;
    this.symptoms = data.details[0]
  }
}
